import './case-study-page.css'
import React from 'react';
import {Helmet} from 'react-helmet-async';
import Header from '../components/header';
import Footer from '../components/footer';
import SlideShow from "../components/SlideShow/SlideShow";
import {useTranslation} from "react-i18next";

const CaseStudyMobileApp = ({showCalModal}) => {
    const {t} = useTranslation();
    const footerMenuItems = [
        <a href="/#home-section-home">
            <span className="Large">{t("footer_menu-home")}</span>
        </a>,
        <a href="/#problems-solutions"><span className="Large">{t("footer_menu-problems-solutions")}</span></a>,
        <a href="/#profile-section">
            <span className="Large">{t("footer_menu-about-me")}</span>
        </a>,
        <a href="/legal">
            <span className="Large">{t("footer_menu-impressum")}</span>
        </a>,
        <a href="/privacy">
            <span className="Large">{t("footer_menu-privacy")}</span>
        </a>
    ]
    return (
        <div className="case-study-container">
            <Helmet>
                <title>{t("case-study-mobileapp-title")}</title>
                <meta
                    name="description"
                    content={t("case-study-mobileapp-meta-description")}
                />
                <meta
                    property="og:title"
                    content={t("case-study-mobileapp-title")}
                />
                <meta
                    property="og:description"
                    content={t("case-study-mobileapp-meta-description")}
                />
            </Helmet>

            <Header showCalModal={showCalModal}/>

            {/* Hero Section */}
            <section className="case-study-hero">
                <h1 className="case-study-title">
                    {t("case-study-mobileapp-title")}
                </h1>
            </section>

            {/* Main Content */}
            <main className="case-study-content">
                {/* Overview */}
                <section className="case-study-section">
                    <h2 className="case-study-section-title HeadingOne">{t("case-study-mobileapp-overview-title")}</h2>
                    <p className="case-study-body">
                        {t("case-study-mobileapp-overview-text")}
                    </p>

                    <div className={"outer-slideshow-container"}>
                        <div className={"inner-slideshow-container"}>
                            <SlideShow images={["/badee-1.jpg", "/badee-2.jpg", "/badee-3.jpg"]}/>
                        </div>
                    </div>
                </section>

                {/* Challenges and Goals */}
                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study-mobileapp-challenges-title")}</h2>
                    <h3 className="case-study-subtitle">{t("case-study-mobileapp-key-challenges-title")}</h3>
                    <ul className="case-study-body">
                        <li>
                            <strong>{t("case-study-mobileapp-challenge-time-market")}</strong> {t("case-study-mobileapp-challenge-time-market-text")}
                        </li>
                        <li>
                            <strong>{t("case-study-mobileapp-challenge-cross-platform")}</strong> {t("case-study-mobileapp-challenge-cross-platform-text")}
                        </li>
                        <li>
                            <strong>{t("case-study-mobileapp-challenge-ranking")}</strong> {t("case-study-mobileapp-challenge-ranking-text")}
                        </li>
                        <li>
                            <strong>{t("case-study-mobileapp-challenge-chat")}</strong> {t("case-study-mobileapp-challenge-chat-text")}
                        </li>
                        <li>
                            <strong>{t("case-study-mobileapp-challenge-scalability")}</strong> {t("case-study-mobileapp-challenge-scalability-text")}
                        </li>
                        <li>
                            <strong>{t("case-study-mobileapp-challenge-security")}</strong> {t("case-study-mobileapp-challenge-security-text")}
                        </li>
                        <li>
                            <strong>{t("case-study-mobileapp-challenge-deployment")}</strong> {t("case-study-mobileapp-challenge-deployment-text")}
                        </li>
                    </ul>
                </section>

                {/* Solution and Technical Stack */}
                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study-mobileapp-solution-title")}</h2>

                    {/* Frontend */}
                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study-mobileapp-frontend-title")}</h3>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-decision")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-frontend-point-1")}</li>
                            <li>{t("case-study-mobileapp-frontend-point-2")}</li>
                            <li>{t("case-study-mobileapp-frontend-point-3")}</li>
                        </ul>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-frontend-benefit-1")}</li>
                            <li>{t("case-study-mobileapp-frontend-benefit-2")}</li>
                        </ul>
                    </article>

                    {/* Backend */}
                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study-mobileapp-backend-title")}</h3>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-decision")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-backend-point-1")}</li>
                            <li>{t("case-study-mobileapp-backend-point-2")}</li>
                            <li>{t("case-study-mobileapp-backend-point-3")}</li>
                            <li>{t("case-study-mobileapp-backend-point-4")}</li>
                        </ul>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-backend-benefit-1")}</li>
                            <li>{t("case-study-mobileapp-backend-benefit-2")}</li>
                            <li>{t("case-study-mobileapp-backend-benefit-3")}</li>
                        </ul>
                    </article>

                    {/* Real-Time Chat */}
                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study-mobileapp-chat-title")}</h3>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-decision")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-chat-point-1")}</li>
                            <li>{t("case-study-mobileapp-chat-point-2")}</li>
                        </ul>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-chat-benefit-1")}</li>
                            <li>{t("case-study-mobileapp-chat-benefit-2")}</li>
                        </ul>
                    </article>

                    {/* Matchmaking & Ranking */}
                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study-mobileapp-business-logic-title")}</h3>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-decision")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-business-logic-point-1")}</li>
                            <li>{t("case-study-mobileapp-business-logic-point-2")}</li>
                        </ul>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-business-logic-benefit-1")}</li>
                            <li>{t("case-study-mobileapp-business-logic-benefit-2")}</li>
                        </ul>
                    </article>

                    {/* Push Notifications */}
                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study-mobileapp-push-notification-title")}</h3>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-decision")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-push-notification-point-1")}</li>
                        </ul>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-push-notification-benefit-1")}</li>
                            <li>{t("case-study-mobileapp-push-notification-benefit-2")}</li>
                        </ul>
                    </article>

                    {/* Cloud Deployment */}
                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study-mobileapp-cloud-deployment-title")}</h3>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-decision")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-cloud-deployment-point-1")}</li>
                            <li>{t("case-study-mobileapp-cloud-deployment-point-2")}</li>
                        </ul>
                        <p className="case-study-body"><strong>{t("case-study-mobileapp-why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study-mobileapp-cloud-deployment-benefit-1")}</li>
                            <li>{t("case-study-mobileapp-cloud-deployment-benefit-2")}</li>
                            <li>{t("case-study-mobileapp-cloud-deployment-benefit-3")}</li>
                        </ul>
                    </article>

                    <div className={"image-container"}>
                        <div className={"image"}>
                            <img src={"/badee_architecture.png"}/>
                        </div>
                    </div>
                </section>

                {/* Results & Benefits */}
                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study-mobileapp-results-title")}</h2>
                    <ul className="case-study-body">
                        <li>✅ {t("case-study-mobileapp-results-point-1")}</li>
                        <li>✅ {t("case-study-mobileapp-results-point-2")}</li>
                        <li>✅ {t("case-study-mobileapp-results-point-3")}</li>
                        <li>✅ {t("case-study-mobileapp-results-point-4")}</li>
                        <li>✅ {t("case-study-mobileapp-results-point-5")}</li>
                        <li>✅ {t("case-study-mobileapp-results-point-6")}</li>
                    </ul>
                </section>

                {/* Key Takeaways */}
                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study-mobileapp-key-takeaways-title")}</h2>
                    <ul className="case-study-body">
                        <li>{t("case-study-mobileapp-key-takeaways-point-1")}</li>
                        <li>{t("case-study-mobileapp-key-takeaways-point-2")}</li>
                        <li>{t("case-study-mobileapp-key-takeaways-point-3")}</li>
                        <li>{t("case-study-mobileapp-key-takeaways-point-4")}</li>
                    </ul>
                </section>

                {/* Conclusion */}
                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study-mobileapp-conclusion-title")}</h2>
                    <p className="case-study-body">{t("case-study-mobileapp-conclusion-text-1")}</p>
                    <p className="case-study-body">{t("case-study-mobileapp-conclusion-text-2")}</p>
                </section>
            </main>

            <Footer footerMenuItems={footerMenuItems}/>
        </div>
    );
};

export default CaseStudyMobileApp;
